module.exports = __webpack_public_path__ + "img/g4.4c9c394d.png";